<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/categorias-imagenes`;
const token = utilsService.getToken();

const categoriaImagenService = {
  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async subir(categoria, file, idUsuarioCreacion) {
    try {
      const fd = new FormData();
      fd.append('categoria', categoria);
      fd.append('file', file);
      fd.append('idUsuarioCreacion', idUsuarioCreacion || 0);

      const response = await axios.post(`${apiUrl}/subir`, fd, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      if (error && error.response) {
        throw error;
      }
      throw {
        response: {
          status: 0,
          data: (error && error.message) ? error.message : 'Error en la solicitud.',
        },
      };
    }
  },
};

export default categoriaImagenService;
</script>
